const breakpointSpecs = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 3,
    xl: 3,
    xxl: 4,
};


export { breakpointSpecs };